goog.provide('el8.appchart.refpanel.problems');

goog.require('el8.appchart.actions.problems');
goog.require('el8.appchart.dialog.addEditProblem');
goog.require('el8.appchart.dialog.problemHx');
goog.require('el8.appchart.metrics');
goog.require('el8.appservice.notifier');
goog.require('el8.ptdata.ptProblems');
goog.require('el8.ptdata.visitNotes');
goog.require('el8.service.infoField');
goog.require('el8.template.appchart.refpanel.problems');
goog.require('el8.uiwidget.collapsible');
goog.require('el8.appchart.refpanel.RefPanelSection');
goog.require('el8.util.consts');
goog.require('el8.util.dom');


el8.appchart.refpanel.problems = (function() {
    var container = $('#problem-section');
    var $activeProblemList = $('#active-problem-summary');
    var clickTexts;
    var isShowingNeedWalk = null;

    var that = new el8.appchart.refpanel.RefPanelSection({

        initFn: function() {
            that.addContainer(container);
            el8.uiwidget.collapsible({
                container: container,
                triggerElt: $('#problem-summary-header'),
                statusElt: $('#problem-summary-status')
            });

            container.on('click', '.hide-details-trigger',  function() {
                var id = $(this).data('id');
                hideSynopsisById(id);
                return false;

            }).on('click', '.show-details-trigger',  function() {
                var id = $(this).data('id');
                showSynopsisById(id);
                return false;

            }).on('click', '.add-problem-trigger',  function() {
                el8.appchart.dialog.addEditProblem.show();

            }).on('click', '.document-none-trigger',  function(e) {
                el8.ptdata.ptProblems.saveAsDocumented();

            }).on('click', '.edit-text-trigger',  function() {
                var itemId = $(this).data('id');
                var patientProblem = el8.ptdata.ptProblems.getById(itemId);
                el8.appchart.dialog.addEditProblem.show({'problem':patientProblem});
                return false;

            }).on('click', '.more-actions-trigger',  function(evt) {
                // don't show actions menu for click on sort handle
                if ($(evt.target).hasClass('problem-sort-handle')) { return; }

                var itemId = $(this).data('id');
                var patientProblem = itemId ? el8.ptdata.ptProblems.getByKey(itemId) : null;
                el8.appchart.refpanel.actionsMenu.display(
                    $(this),
                    patientProblem,
                    {top: 17, left: 5},
                    el8.appchart.actions.problems({ item: patientProblem })
                );
                return false;
            });

            $(document).on('el8_refBoardChange', function() {
                for (var id in clickTexts) {
                    if (clickTexts.hasOwnProperty(id)) {
                        clickTexts[id].triggerResize();
                    }
                }
            });

            /* Initial state is 'hide'; after clicking, will switch to 'show'
             * toggleState of 'hide' means clicking should hide; 'show' means clicking should show */
            var toggleState = 'hide';
            $('#refBoardContainer').on('click', '.problem-list-actions-trigger',  function(e) {
                var menu = [];
                menu.push({
                    actionText: 'Add Problem',
                    actionFn: function() { el8.appchart.dialog.addEditProblem.show(); }
                });

                var hasSynopses = _.some(el8.ptdata.ptProblems.all().map(function(p) { return p.getDetails(); }));
                var hasCodes    = _.some(el8.ptdata.ptProblems.all().map(function(p) { return p.getIcd9Codes().length; }));

                if (el8.appchart.actions.problems.isHpiAComboExportRelevant()) {
                    menu.push({
                        actionText: (el8Globals.FEATURES.AutoImportBilling) ?
                            'Export All Crosswalked (HPI, A, Billing)' : 'Export All (HPI, A)',
                        actionFn: function() {
                            el8.appchart.mgr.notes.referenceProblems(['problem', 'assessment', 'billing']);
                        }
                    });
                }

                menu = menu.concat([
                    {
                        actionText: 'Export All (HPI)',
                        actionFn: function() {
                            el8.appchart.mgr.notes.referenceProblems(['problem']);
                        }
                    },
                    {
                        actionText: 'Export All (ROS)',
                        actionFn: function() {
                            el8.appchart.mgr.notes.referenceProblems(['ros']);
                        }
                    },
                    {
                        actionText: (el8Globals.FEATURES.AutoImportBilling) ?
                            'Export All Crosswalked (A, Billing)' : 'Export All (A)',
                        actionFn: function() {
                            el8.appchart.mgr.notes.referenceProblems(['assessment', 'billing']);
                        }
                    }
                ]);
                if (hasSynopses) {
                    menu.push({
                        actionText: (el8Globals.FEATURES.AutoImportBilling) ?
                            'Export All Crosswalked w/ Synopses (A, Billing)' : 'Export All w/ Synopses (A)',
                        actionFn: function() {
                            el8.appchart.mgr.notes.referenceProblems(['synopses'], true);
                        }
                    });
                }
                if (el8Globals.FEATURES.AutoImportBilling && hasCodes) {
                    menu.push({
                        actionText: 'Export All Crosswalked (Billing)',
                        actionFn: function() {
                            el8.appchart.mgr.notes.referenceProblems(['billing']);
                        }
                    });
                }
                menu.push({
                    actionText: 'View Hx',
                    actionFn: function() { el8.appchart.dialog.problemHx.show(); }
                });

                if (hasSynopses) {
                    menu.push({
                        actionText: toggleState.capitalize() + ' Synopses',
                        actionFn: function() {
                            el8.ptdata.ptProblems.all().map(function(p) {
                                if (toggleState === 'hide') {
                                    hideSynopsisById(p.getId());
                                } else {
                                    showSynopsisById(p.getId());
                                }
                            });

                            if (toggleState === 'hide') {
                                toggleState = 'show';
                            } else {
                                toggleState = 'hide';
                            }
                        }
                    });
                }

                el8.appchart.refpanel.actionsMenu.display(
                    $(this),
                    null,
                    {'top': 17, 'left': 20},
                    menu
                );
                return false;
            });

            // RM-40312: Constrain sortable to vertical scroll to limit scroll-off-screen bug
            $activeProblemList.sortable({
                axis: 'y',
                items: 'li.problemActive', // only active problems are sortable
                handle: '.problem-sort-handle',
                cursor: 'move',
                start: function() {
                    $activeProblemList.addClass('sortActivatedArea');
                    // don't leave a displaced actions menu behind
                    el8.appchart.refpanel.actionsMenu.hide();
                },
                stop: function() {
                    $activeProblemList.removeClass('sortActivatedArea');
                },
                update: function() {
                    sortSaveFn();
                }
            });
        },
        dataRenderers: [
            {
                entitySet: el8.ptdata.ptProblems,
                events: [{
                    eventName: 'all',
                    fn: renderFn
                }],
                renderFn: renderFn
            }
        ]
    });

    function setXWalkVisibility(isShowing) {
        if (isShowing) {
            $('.el8ProblemNeedsXWalk', container).addClass('el8ProblemNeedsXWalkHighlight');
            $('.show-needs-xwalk-trigger', container).text('Hide');
            isShowingNeedWalk = true;
        } else {
            $('.el8ProblemNeedsXWalk', container).removeClass('el8ProblemNeedsXWalkHighlight');
            $('.show-needs-xwalk-trigger', container).text('Show');
            isShowingNeedWalk = false;
        }
    }

    // Add problem list notifier click handlers
    container.on('click', '.show-needs-xwalk-trigger',  function() {
        setXWalkVisibility(!isShowingNeedWalk);
    }).on('click', '.dismiss-needs-xwalk-trigger',  function(evt) {
        el8.ptdata.ptProblems.dismissXWalkNotifier(renderFn);
    });
    
    container.on('click', '.fix-outdated-dx-trigger', function () {
        // Open for edit first encountered problem with deprecated IMO/DX mappings
        var problems = el8.ptdata.ptProblems.sorted();
        for (var i = 0; i < problems.length; i++) {
            if (problems[i].isDxOutdated()) {
                el8.appchart.dialog.addEditProblem.show({'problem': problems[i]});
                break;
            }
        }
    });

    function _refreshProblemsIfBilled(visitNote) {

        // Billing info in unsigned visit notes currently does not (nor is intended to) cause
        // changes to the problem list, e.g. the 'Last Addressed' dates, where a problem is
        // considered addressed only after the visit note is signed.
        if (visitNote.getSignDate() === null) { return; }
        if (visitNote.getBill() === null) { return; }

        el8.ptdata.ptProblems.load();
    }

    if (el8.data.practiceSettings.isHccScoringEnabled()) {
        // Refresh 'Last Addressed' dates for HCC-relevant problems whenever billing changes,
        // in case the bill contains or used to contain an ICD10 code for one or more problems.
        // EVENTS.UPDATED is triggered by el8.ptdata.model.note.visit whenever the bill is
        // changed, even after the note has been signed.
        el8.ptdata.visitNotes.bind(EVENTS.UPDATED, _refreshProblemsIfBilled);
        el8.ptdata.visitNotes.bind(EVENTS.DELETED, _refreshProblemsIfBilled);
    }

    var reportOnFirstLoad = el8.appchart.metrics.getChartLoadCallback('problems');

    function renderFn() {

        $activeProblemList.removeClass('el8Loading');

        clickTexts = {};

        $('.problem-buttons', container).html(
            el8.template.appchart.refpanel.problems.addNewTrigger({
                isNotDocumented: el8.ptdata.ptProblems.isNotDocumented()
            })
        );

        var items = el8.ptdata.ptProblems.sorted();
        var activeProblems = [];
        var resolvedProblems = [];
        var controlledProblems = [];
        var hasSynopses = false;
        var needsXWalkCount = 0;
        var dxOutdatedCount = 0;

        for (var i=0; i<items.length; i++) {
            var curr = items[i];

            if (!hasSynopses && curr.getDetails()) { hasSynopses = true; }
            if (curr.getStatus() === 'Resolved') {
                resolvedProblems.push(curr);
            } else if (curr.getStatus() === 'Controlled') {
                controlledProblems.push(curr);
            } else {
                activeProblems.push(curr);
            }

            // If we have non-imo icd9 codes and no imos, this needs xwalked. Note:
            // we'll clear any legacy icd9s on save of this problem
            if (curr.getNonImoIcd9Codes().length &&
                !curr.getImoIds().length &&
                curr.getStatus() !== 'Resolved') {
                needsXWalkCount += 1;
            }

            // If we have any problems with IMO mappings to possibly non-billable or deprecated codes, 
            // we must signal the user to fix them
            if (curr.isDxOutdated()) {
                dxOutdatedCount += 1;
            }
        }

        if (!items.length && el8.ptdata.ptProblems.isDocumentedAsNone()) {
            $activeProblemList.html(el8.template.appchart.refpanel.problems.documentedAsNone());
            $('#other-problem-summary').empty();

        } else if (el8.ptdata.ptProblems.isNotDocumented()) {
            $activeProblemList.html(el8.template.appchart.refpanel.problems.notDocumented());
            $('#other-problem-summary').empty();

        } else {
            var activeProblemsSoyMap = activeProblems.map(el8.model.toSoyMapFn);
            var isHccScoringEnabled = el8.data.practiceSettings.isHccScoringEnabled();
            var isShowDualCodingDisabled = !el8.data.currUser.isShowDualCodingEnabled();
            
            $activeProblemList.html(
                el8.template.appchart.refpanel.problems.activeProblemList({
                    actives: activeProblemsSoyMap,
                    hccScoringEnabled: isHccScoringEnabled,
                    showDualCodingDisabled: isShowDualCodingDisabled
                })
            );
            $('#other-problem-summary').html(
                el8.template.appchart.refpanel.problems.otherProblemList({
                    resolveds: resolvedProblems.map(el8.model.toSoyMapFn),
                    controlleds: controlledProblems.map(el8.model.toSoyMapFn),
                    hccScoringEnabled: isHccScoringEnabled,
                    showDualCodingDisabled: isShowDualCodingDisabled
                })
            );
        }

        /* Only show the hide synopses trigger if there are synopses */
        if (hasSynopses) {
            $('#toggle-problem-synopses-trigger').show();
        } else {
            $('#toggle-problem-synopses-trigger').hide();
        }

        $('.details-field', container).each(function(index, elt) {
            var $elt = $(elt);
            var id = $elt.data('id');
            var problem = el8.ptdata.ptProblems.getById(id);
            clickTexts[id] = initSynopsisField($elt, problem);
        });

        // update list of sortable problems
        $activeProblemList.sortable('refresh');

        // show problem list notifier for problems containing possibly outdated, non-billable DX codes
        if (dxOutdatedCount > 0) {
            $('#problem-outdated-dx-notifier').html(
                el8.template.appchart.refpanel.problems.problemListNotifierOutdatedDx({
                    dxOutdatedCount: dxOutdatedCount
                })
            ).show();
        } else {
            $('#problem-outdated-dx-notifier').hide();
        }

        // show the xwalk notifier, if not dismissed
        if (needsXWalkCount && !el8.ptdata.ptProblems.isXWalkNotifierDismissed()) {
            $('#problem-xwalk-notifier').html(
                el8.template.appchart.refpanel.problems.xWalkNotifier({
                    needsXWalkCount: needsXWalkCount
                })
            ).show();
        } else {
            $('#problem-xwalk-notifier').hide();
        }

        // if we're re-rendering, respect the state if we're showing the needs xwalk problems
        if (isShowingNeedWalk) {
            setXWalkVisibility(true);
        }
        // also if we're in Explore, where we want people to check this out
        if (el8Globals.TEASE) {
            setXWalkVisibility(true);
        }

        reportOnFirstLoad();
    }

    function sortSaveFn() {
        var listArray = [];
        $('li', $activeProblemList).each( function() {
            if ($(this).data('id')) {
                listArray.push($(this).data('id'));
            }
        });
        $.el8_ajax({
            url: el8.service.urls.get('sortProblems'),
            type: 'POST',
            data: JSON.stringify({rank: listArray}),
            success: function(data){
                el8.ptdata.ptProblems.create(data, true);
                el8.appservice.notifier.notify('Ordering of active problems updated.');
            }
        });
    }

    function showSynopsisById(id) {
        var $probElt = $('#ptprob_'+id, container);
        $probElt.find('.details-icon').hide();
        $probElt.find('.details-section').show();
        $probElt.find('.show-details-trigger').hide();
    }

    function hideSynopsisById(id) {
        var $probElt = $('#ptprob_'+id, container);
        $probElt.find('.details-icon').show();
        $probElt.find('.show-details-trigger').show();
        $probElt.find('.details-section').hide();
    }

    function initSynopsisField($elt, problem) {
        return (new el8.uiwidget.ClickText({
            changeFn: function(text) {
                problem.setDetails(text);
                el8.ptdata.ptProblems.saveItem(problem);
            }
        })).init({
            elt: $elt,
            initText: problem.getDetails()
        });
    }

    return that;

})();
